import { IdoPrintListItem, normalizeIdoPrintRow } from 'src/models/idoPrint';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { IdoPrintListCallbackStoreContract } from '../interfaces';

export class GetTheIdoPrintListQueryCallback extends Callback<Array<unknown>> {
	public constructor(
		private readonly store: IdoPrintListCallbackStoreContract,
		private readonly idoId: number,
		private readonly instanceId: number
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.applyThePrintList({
			idoId: this.idoId,
			instanceId: this.instanceId,
			rows: [],
			totalCount: 0,
		});
	};

	successCallbackFunction = (
		successResponse: Array<unknown>,
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		this.store.applyThePrintList({
			idoId: this.idoId,
			instanceId: this.instanceId,
			rows: successResponse.map(normalizeIdoPrintRow).filter((row): row is IdoPrintListItem => row !== null),
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
